import React, { useCallback, useEffect, useState } from "react";

import Container from "react-bootstrap/Container";
import { useHistory } from "react-router-dom";

import styles from "./Layout.module.scss";
import { Navigation } from "./Navigation";
import {
  getUserManual,
  getStatement,
} from "../../api/UserManual/UserManualApi";
import { useTypedSelector } from "../../app/rootReducer";
import { Footer, FooterItem } from "../../components/Footer/Footer";
import RouteLeavingGuard from "../../components/RouteLeavingGuard";
import { Navbar } from "../Navbar/Navbar";
import { Sidebar } from "../Sidebar/Sidebar";

interface Props {
  children?: React.ReactNode;
}

export interface MatchParams {
  requestId: string;
  id: string;
}

export default function Layout({ children }: Props) {
  const history = useHistory();
  const [showSidebar, setShowSidebar] = useState<boolean>(true);

  const showFaq = () => history.push("/faq");

  const downloadUserManual = () => {
    getUserManual();
  };

  const showHelpAndSupport = () => history.push("/help-and-support");
  const showAboutProgram = () => history.push("/aboutprogram");
  const showStatementOfAccessibility = () => {
    window.scrollTo(0, 0);
    history.push("/statement-of-accessibility");
  };

  const footerItems: Array<FooterItem> = [
    {
      label: "Česta pitanja",
      callback: (item: FooterItem) => {
        showFaq();
        return false;
      },
    },
    {
      label: "Korisničke upute",
      callback: (item: FooterItem) => {
        showFaq();
        // downloadUserManual(); // TODO: Remove this when user manual is ready
        return false;
      },
    },
    {
      label: "Pomoć i podrška",
      callback: (item: FooterItem) => {
        showHelpAndSupport();
        return false;
      },
    },
    {
      label: "O programu",
      callback: (item: FooterItem) => {
        showAboutProgram();
        return false;
      },
    },
    // { label: 'Izjava o pristupačnosti', callback: (item: FooterItem) => { getStatement(); return false } },
    {
      label: "Izjava o pristupačnosti",
      callback: (item: FooterItem) => {
        showStatementOfAccessibility();
        return false;
      },
    },
  ];

  const setImpairedStyle = useCallback(() => {
    document.documentElement.classList.add("theme-vision-impaired");
    document.documentElement.classList.remove("theme-default");
  }, []);

  const removeImpairedStyle = useCallback(() => {
    document.documentElement.classList.add("theme-default");
    document.documentElement.classList.remove("theme-vision-impaired");
  }, []);

  //prevent browser close in if form isedited
  const isEdited: boolean = useTypedSelector(
    (state) => state.application.isEdited
  );
  useEffect(() => {
    if (isEdited) {
      window.addEventListener("beforeunload", alertUser);
      return () => {
        window.removeEventListener("beforeunload", alertUser);
      };
    }
  }, [isEdited]);

  const alertUser = (event: any) => {
    event.preventDefault();
    event.returnValue = "";
  };

  return (
    <>
      <Navbar
        setImpairedStyle={setImpairedStyle}
        removeImpairedStyle={removeImpairedStyle}
      />
      <Navigation onIconClick={() => setShowSidebar(!showSidebar)} />
      <main className={styles.main}>
        <Container fluid>
          <RouteLeavingGuard
            when={isEdited}
            navigate={(path) => {
              history.push(path);
            }}
          />
          <Sidebar sidebarIsOpen={showSidebar} />
          {children}
        </Container>
      </main>
      <Footer items={footerItems} />
    </>
  );
}
